export const buildFirewallPoliciesStatusData = policies => ([{
    name: 'Input',
    status: policies.input_p === 'accept' ? '1' : '0'
}, {
    name: 'Output',
    status: policies.output_p === 'accept' ? '1' : '0'
}, {
    name: 'Forward',
    status: policies.forward_p === 'accept' ? '1' : '0'
}]);
